import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import {
  CreateKioskApi,
  CreateKioskFailureApi,
  CreateKioskSuccessApi,
  DeleteKioskApi,
  DeleteKioskFailureApi,
  DeleteKioskSuccessApi,
  KioskApiActionTypes,
  LoadKioskApi,
  LoadKioskFailureApi,
  LoadKiosksApi,
  LoadKiosksFailureApi,
  LoadKiosksSuccessApi,
  LoadKioskSuccessApi,
  UpdateKioskApi,
  UpdateKioskFailureApi,
  UpdateKioskSuccessApi,
} from './kiosk-api.actions';
import { KioskApiService } from './kiosk-api.service';

@Injectable()
export class KioskApiEffects {
  loadKiosksApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KioskApiActionTypes.LoadKiosksApi),
      switchMap(({ payload: { params, isCA } }: LoadKiosksApi) =>
        this.srv.get(params, isCA).pipe(
          map((kiosks) => new LoadKiosksSuccessApi({ kiosks })),
          catchError((err) => of(new LoadKiosksFailureApi(err)))
        )
      )
    )
  );

  loadOneKiosksApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KioskApiActionTypes.LoadKioskApi),
      switchMap(({ payload: { id, isCA } }: LoadKioskApi) =>
        this.srv.getOne(id, isCA).pipe(
          map((kiosk) => new LoadKioskSuccessApi({ kiosk })),
          catchError(({ message }) => of(new LoadKioskFailureApi({ id, message })))
        )
      )
    )
  );

  createKioskApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KioskApiActionTypes.CreateKioskApi),
      mergeMap(({ payload }: CreateKioskApi) =>
        this.srv.create(payload.kiosk, payload.isCA).pipe(
          map((kiosk) => new CreateKioskSuccessApi({ kiosk })),
          catchError((error) => of(new CreateKioskFailureApi(error)))
        )
      )
    )
  );

  updateKioskApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KioskApiActionTypes.UpdateKioskApi),
      mergeMap(({ payload }: UpdateKioskApi) =>
        this.srv.update(payload.kiosk, payload.isCA).pipe(
          map((kiosk) => new UpdateKioskSuccessApi({ kiosk })),
          catchError((error) => of(new UpdateKioskFailureApi(error)))
        )
      )
    )
  );

  deleteKioskApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KioskApiActionTypes.DeleteKioskApi),
      mergeMap(({ payload }: DeleteKioskApi) =>
        this.srv.delete(payload.id, payload.isCA).pipe(
          map(({ id }) => new DeleteKioskSuccessApi({ id: payload.id })),
          catchError((err) => of(new DeleteKioskFailureApi(err)))
        )
      )
    )
  );

  constructor(private actions$: Actions, private srv: KioskApiService) {}
}
